define('modules/lp_integration/models/integration_post',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");
  module.exports = Backbone.Model.extend({
    defaults: {
      active: false,
      url: "",
      fields: {}
    },
    url: function(){
      return [config.apiHost, "pages", this.pageId, "integration", "webservice"].join("/");
    },
    initialize: function(attrs,options){
      this.pageId = options.pageId;
    },
    toJSON: function(){
      return _.omit(module.exports.__super__.toJSON.apply(this), "id");
    },
    validate: function(attrs,options){
      var errors = [];

      if(!attrs.url || attrs.url.trim() === ""){
        errors.push({
          attribute: "url"
        });
      }

      if(_.isEmpty(attrs.fields)){
        errors.push({
          attribute: "fields"
        });
      }

      if(errors.length){
        this.set("active",false);
        return errors;
      }
    },
    
    isEmpty: function(){
      return !this.get("url") && _.isEmpty(this.get("fields"));
    },

  });
});

